import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const navigate = useNavigate();

  const resources = [
    {
      title: "Consultation Services",
      description: "Expert guidance on complex compliance matters",
      icon: "MessageSquare",
      action: () => navigate('/contact'),
      buttonText: "Book Consultation"
    },
    {
      title: "Client Portal Access",
      description: "Secure access to compliance documentation",
      icon: "Lock",
      action: () => navigate('/client-portal'),
      buttonText: "Access Portal"
    },
    {
      title: "Market Intelligence",
      description: "Transfer insights and regulatory analysis",
      icon: "BarChart3",
      action: () => navigate('/market-intelligence'),
      buttonText: "View Insights"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary via-primary/95 to-primary/90 text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 md:mb-6 font-headline">
            Need Compliance Assistance?
          </h2>
          <p className="text-base md:text-lg text-primary-foreground/90 max-w-3xl mx-auto">
            Our compliance experts are ready to help you navigate complex regulations and ensure your transfers meet all FIFA and international standards.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-10 md:mb-12 lg:mb-16">
          {resources?.map((resource, index) => (
            <div
              key={index}
              className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl border border-primary-foreground/20 p-6 md:p-8 hover:bg-primary-foreground/15 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 bg-primary-foreground/20 rounded-lg flex items-center justify-center mb-6">
                <Icon name={resource?.icon} size={28} />
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-3 font-headline">
                {resource?.title}
              </h3>
              <p className="text-sm md:text-base text-primary-foreground/80 mb-6">
                {resource?.description}
              </p>
              <Button
                variant="outline"
                fullWidth
                onClick={resource?.action}
                className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10"
              >
                {resource?.buttonText}
              </Button>
            </div>
          ))}
        </div>

        <div className="bg-primary-foreground/10 backdrop-blur-sm rounded-xl border border-primary-foreground/20 p-6 md:p-8 lg:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-xl md:text-2xl lg:text-3xl font-bold mb-4 font-headline">
                Questions About Compliance?
              </h3>
              <p className="text-sm md:text-base text-primary-foreground/90 mb-6">
                Our compliance team is available to answer your questions about FIFA regulations, transfer processes, work permits, and any other regulatory matters.
              </p>
              <div className="flex flex-wrap gap-4">
                <Button
                  variant="default"
                  iconName="Phone"
                  iconPosition="left"
                  onClick={() => navigate('/contact')}
                  className="bg-primary-foreground text-primary hover:bg-primary-foreground/90"
                >
                  Contact Us
                </Button>
                <Button
                  variant="outline"
                  iconName="Download"
                  iconPosition="left"
                  className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10"
                >
                  Download Guide
                </Button>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-4 p-4 bg-primary-foreground/10 rounded-lg">
                <Icon name="Clock" size={24} className="flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-bold mb-1">24/7 Support</h4>
                  <p className="text-sm text-primary-foreground/80">
                    Round-the-clock assistance for urgent compliance matters
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-primary-foreground/10 rounded-lg">
                <Icon name="Users" size={24} className="flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-bold mb-1">Expert Team</h4>
                  <p className="text-sm text-primary-foreground/80">
                    FIFA-certified professionals with extensive experience
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-primary-foreground/10 rounded-lg">
                <Icon name="Shield" size={24} className="flex-shrink-0 mt-1" />
                <div>
                  <h4 className="font-bold mb-1">100% Compliant</h4>
                  <p className="text-sm text-primary-foreground/80">
                    Guaranteed adherence to all FIFA and international regulations
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;